export const formatBytes = (bytes: number, decimals = 2): string => {
  if (!Number.isFinite(bytes) || bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = Math.max(decimals, 0);
  const sizes = ["Bytes","KB","MB","GB","TB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const value = bytes / Math.pow(k, i);
  
  return Number.parseFloat(value.toFixed(dm)) + " " + sizes[i];
}
